/*global _ */
import {mapGetters, mapActions} from 'vuex'
import PagesMixin from '../../../../mixins/pages'

/**
 * By default, in guest mode, `Sign in` link is shown.
 * After authentication, all pages except the Profile page show `My Profile` link whereas Profile page shows `Sign Out` link
 *
 * To force both `Sign Out` and `My Profile` links to be shown:
 *   - Set `signOutOnlyInProfile` prop to false. This will show both links in all pages except the Profile page.
 *   - Set `showProfileInProfile` prop to true. This will show both links in the Profile page.
 *
 */
export default {
  name: 're-login-status',
  mixins: [PagesMixin],
  props: {
    containerClass: {
      type: [String, Array, Object],
      default: ''
    },
    signInLabel: {
      type: String,
      default: 'Sign in'
    },
    signInClass: {
      type: [String, Array, Object],
      default: 're-status-sign-in-link'
    },
    signInLink: {
      type: [String, Object],
      default: () => ({name: 'sign-in'})
    },
    noSignInLink: {
      type: Boolean,
      default: false
    },
    signOutLabel: {
      type: String,
      default: 'Sign out'
    },
    signOutClass: {
      type: [String, Array, Object],
      default: 're-status-sign-out-link'
    },
    noSignOutLink: {
      type: Boolean,
      default: false
    },
    profileLabel: {
      type: String,
      default: 'My Account'
    },
    profileClass: {
      type: [String, Array, Object],
      default: 're-status-profile-link'
    },
    profileLink: {
      type: [String, Object],
      default: () => ({name: 'user.profile'})
    },
    noProfileLink: {
      type: Boolean,
      default: false
    },
    signOutOnlyInProfile: {
      type: Boolean,
      default: true
    },
    showProfileInProfile: {
      type: Boolean,
      default: false
    },
    reloadAfterSignOut: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {}
  },

  created() {
  },
  computed: {
    routeIsProfile() {
      const routeName = this.$route.name
      let isProfile = false
      if (!routeName) {
        const route = _.trim(this.getRouteUrl('user.profile'), '/')
        const path = _.trim(location.pathname, '/')
        isProfile = route === path
      } else {
        isProfile = routeName === 'user.profile'
      }
      return isProfile
    },

    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck',
    }),
    isAuthenticated() {
      return this.authenticated && this.user && this.user.verified
    },
    showSignInLink() {
      const canShow = !this.noSignInLink
      return !this.isAuthenticated && canShow
    },
    showProfileLink() {
      const canShow = !this.noProfileLink && (!this.routeIsProfile || this.showProfileInProfile)
      return this.isAuthenticated && canShow
    },
    showSignOutLink() {
      const canShow = !this.noSignOutLink && (this.routeIsProfile || !this.signOutOnlyInProfile)
      return this.isAuthenticated && canShow
    }
  },
  methods: {
    ...mapActions(['logout']),

    async userSignOut() {
      await this.logout()
      if (this.reloadAfterSignOut) {
        window.location.reload()
      }
    }
  }
}
